import { SecurityService } from 'src/app/security/services/security.service';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable()
export class RoutingService {
  constructor(private router: Router) {}

  navigateHome(): void {
    this.router.navigate(['/app/']);
  }

  navigateToClientDashboard(): void {
    this.router.navigate(['/clients/']);
  }

  navigateToProfile(): void {
    this.router.navigate(['/app/account']);
  }

  navigateToSO(): void {
    this.router.navigate(['/app/account/subject-obligated']);
  }

  navigateToLoginPage(): void {
    this.router.navigate(['/login']);
  }

  navigateToUserDetail(employeeId: number): void {
    this.router.navigate(['/app/users/', employeeId]);
  }

  navigateToClientDetail(clientId: number): void {
    this.router.navigate(['/app/clients/', clientId]);
  }

  navigateToUserIndex(): void {
    this.router.navigate(['/app/users/']);
  }

  navigateToClientIndex(): void {
    this.router.navigate(['/app/clients/']);
  }

  navigateToContractSummaryDetail(contractId: number, relative?: ActivatedRoute): void {
    this.router.navigate(['/view/summary/contract/', contractId], {relativeTo: relative });
  }

  navigateToContractPermissionApproval(contractId: number, contractType: string, relative?: ActivatedRoute): void {
    this.router.navigate([`/view/summary/contract/approval/${contractId}/${contractType}`], {relativeTo: relative });
  }
}
